import cn from 'classnames';
// Ui
import Button from 'ui3/Button/Button';
import Text from 'ui3/Text/Text';
// Styles
import styles from './CreatorCard.module.scss';

type CreatorCardProps = {
  className?: string;
  onConfirmClick: () => void;
};

const CREATOR_CARD_LOGO_SRC = '/images/logos/millions-3d-icon.png';

const CreatorCard = ({ className, onConfirmClick }: CreatorCardProps) => {
  return (
    <div className={cn(styles.root, className)}>
      <img
        src={CREATOR_CARD_LOGO_SRC}
        alt="3d-icon"
        className={styles.millions3dIcon}
        width={66}
        height={64}
        aria-hidden
      />
      <Text className={styles.title} variant="subtitle1">
        Become a Creator
      </Text>

      <Text className={styles.description} variant="body2Regular">
        Access brand deals, create products, host streams, and more.
      </Text>

      <div className={styles.actions}>
        <Button
          className={styles.goProButton}
          variant="primary"
          onClick={onConfirmClick}
        >
          Go Pro
        </Button>
      </div>
    </div>
  );
};

export default CreatorCard;
